<template>
  <div id="app">
    <!-- <div class="img">
      <img src="./assets/image/bg.png" alt="" srcset="" style="width:100%">
    </div> -->
    <navComp v-if="!flag" />
    <transition name="fade-transform" mode="out-in">
      <router-view v-if="$store.getters.metaMaskObj.initOk"/>
    </transition>
    <el-backtop :bottom="100"></el-backtop>
  </div>
</template>

<script>
import navComp from "@/views/home/navBar/index.vue"
export default  {
  name:  'App',
  components:{
    navComp
  },
  computed:{
    flag(){
      return this.$route.path === '/404'
    }
  }

}
</script>
<style scoped>
#app{
  /* background: url(./assets/image/bg2.png) no-repeat center bottom/100%,  */
  background: url(./assets/image/bg.png) no-repeat center top/100%, #020202;
  min-height: 100vh;
  font-family: Roboto-Regular,DMSans-Regular;
  position: relative;
  max-width: 100vw;
  overflow: hidden;
}
#app .img{
  width: 100%;
  position: absolute;
  left: 0;
  top:0;
  z-index: -10;
}
#app /deep/ .el-backtop{
  color: #2675F1;
  z-index: 100;
}

</style>
